/**
 * Sidebar "My Team" item with a live open-asks count badge. Rendered ONLY for
 * managers (Layout gates on useIsManager), so useTodos doesn't run for everyone.
 */
import { NavLink } from 'react-router-dom';
import { useSharedTodos } from '../notifications/TodosContext';
import { managerTodos } from './managerTodos';
import { SeenBadge, todosSig } from '../notifications/seen';
import { Users } from 'lucide-react';
import { Icon } from '../design/Icon';

export function MyTeamNavItem({ className, collapsed = false }: { className: (p: { isActive: boolean }) => string; collapsed?: boolean }) {
  const mine = managerTodos(useSharedTodos());
  const n = mine.length;
  // Hides once My Team has been visited; returns when the set of asks changes.
  const sig = todosSig(mine);
  return (
    <NavLink to="/my-team" className={className} aria-label={collapsed ? `My Team${n > 0 ? ` (${n})` : ''}` : undefined} title={collapsed ? 'My Team' : undefined}>
      <Icon as={Users} />
      <span className={collapsed ? 'hidden' : 'truncate'}>My Team</span>
      {n > 0 && (
        <SeenBadge
          badgeKey={`/my-team:${sig}`}
          markRoute="/my-team"
          count={n}
          className={`ml-auto inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-brand-solid text-white text-2xs font-semibold tabular-nums ${collapsed ? 'hidden' : ''}`}
        />
      )}
    </NavLink>
  );
}
